import Vue from 'vue/dist/vue.esm';

import GoogleAutocomplete from './GoogleAutocomplete.vue';
import { makeAjaxClient, ajaxUrl } from '../fn/api';

const config = window.appLabels.startBox;

const client = makeAjaxClient();

const ADDRESS_COMPONENTS = {
    subpremise : 'short_name',
    street_number: 'short_name',
    route: 'long_name',
    locality: 'long_name',
    administrative_area_level_1: 'short_name',
    administrative_area_level_2: 'long_name',
    country: 'long_name',
    postal_code: 'short_name'
};

export default Vue.extend({
    template: '#startBox',

    components: {
        VueGoogleAutocomplete: GoogleAutocomplete,
    },

    data() {
        return {
            subTypeOptions: [
                {
                    key: 'move',
                    title: config.moveOnly,
                },
                {
                    key: 'move_store',
                    title: config.moveAndStore,
                },
                {
                    key: 'store',
                    title: config.storeOnly,
                },
            ],

            subType: 'move',

            calculateStorageTransport: 'false',

            moveout: {
                address: '',
                nr: '',
                isDisabled: true,
            },

            movein: {
                address: '',
                nr: '',
                isDisabled: true,
            },


            area: 0,

            rooms: 1,

            loading: false,
        };
    },

    mounted() {
        const options = window.STARTBOX_OPTIONS;

        if (options) {
            this.subType = options.subType;
            this.moveout.address = options.moveoutAddress;
            this.movein.address = options.moveinAddress;
            this.area = options.area;
            this.calculateStorageTransport = options.calculateStorageTransport;

            this.$refs.moveoutInputEl.update(this.moveout.address);
            this.$refs.moveinInputEl.update(this.movein.address);
        }
    },

    computed: {
        requiresMovein() {
            return this.subType !== 'store';
        },
        showStoreConfig() {
            return this.subType === 'store';
        },
        requiresArea() {
            return this.subType !== 'store';
        },
    },

    methods: {
        async submit() {
            if (!this.validate()) {
                return;
            }

            this.loading = true;

            const vars = {
                action: 'validate_private_move',
                move_type: 'ORDER_MOVE',
                move_subtype: this.subType,
                storage_transport: this.calculateStorageTransport === 'true',
                rooms: this.rooms,
                square_meters: this.area,
                address_old: this.moveout.nr + ' ' + this.moveout.address,
                address_new: this.movein.nr + ' ' + this.movein.address,
            };

            const data = new URLSearchParams();

            for (const key of Object.keys(vars)) {
                data.set(key, vars[key]);
            }

            const r = await client.post(ajaxUrl, {
                body: data,
                headers: {
                    'content-type': 'application/x-www-form-urlencoded',
                },
            });

            if (!r.ok) {
                alert('Fehler');

                this.loading = false;

                return;
            }

            const result = await r.json();

            if (result.success && result.url) {
                // If in an iframe, window.parent will be the window wrapping the iframe. If not
                // window.parent will refer to itself
                window.parent.location.href = result.url;
            } else if (result.errors) {
                alert(result.errors.join('\n'));

                this.loading = false;
            }
        },

        validate() {
            if (this.moveout.address.trim() === '') {
                alert(config.addressMissing);

                return false;
            }

            if (this.requiresArea && (Number.isNaN(this.area) || Number(this.area) <= 0)) {
                alert(config.areaInvalid);

                return false;
            }

            if (this.requiresMovein && this.movein.address.trim() === '') {
                alert(config.addressMissing);

                return false;
            }

            return true;
        },

        moveinChanged(address, place) {
            const returnData = this.validatePlaceData(place);

            // if streetnumber are present in response, disable nr-input
            this.movein.isDisabled = Object.prototype.hasOwnProperty.call(returnData, 'street_number') && returnData.street_number !== '';

            this.movein.address = place.formatted_address;
        },

        moveinTextChanged(newVal) {
            this.movein.address = newVal;
        },

        moveoutChanged(address, place) {
            const returnData = this.validatePlaceData(place);

            // if streetnumber are present in response, disable nr-input
            this.moveout.isDisabled = Object.prototype.hasOwnProperty.call(returnData, 'street_number') && returnData.street_number !== '';

            this.moveout.address = place.formatted_address;
        },

        moveoutTextChanged(newVal) {
            this.moveout.address = newVal;
        },

        validatePlaceData(place) {
            let returnData = {};
            for (let i = 0; i < place.address_components.length; i++) {
                let addressType = place.address_components[i].types[0];

                if (ADDRESS_COMPONENTS[addressType]) {
                    returnData[addressType] = place.address_components[i][ADDRESS_COMPONENTS[addressType]];
                }
            }

            return returnData;
        }
    },
});
